export default class MobileUtil {

  public static readonly desktopWidth = 1024;

  public static isMobile(width: number) {
    return width < this.desktopWidth;
  }
}
